import styled from 'styled-components';

export const DropdownSelectTriggerLabel = styled.span<{ align: 'left' | 'right' }>`
    margin-inline-end: 24px;
    margin-inline-start: ${({ align }) => (align === 'right' ? 'auto' : 0)};
    color: inherit;

    &[data-placeholder='true'] {
        color: ${({ theme }) => theme.bento.colors.text.weak};
    }
`;
